<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="使用する農薬の選択">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-row dense>
                        <v-col>
                            <v-card outlined class="pa-0">
                                <v-card-text class="pa-0">
                                    <v-container fluid>
                                        <v-row dense>
                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-text-field
                                                    dense
                                                    v-model="conditions.name" 
                                                    label="農薬名" 
                                                    outlined 
                                                    hide-details
                                                    clearable />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-select
                                                    dense
                                                    v-model="conditions.sick" 
                                                    label="病気" 
                                                    outlined 
                                                    hide-details
                                                    :items="sicks" 
                                                    item-text="name"
                                                    clearable
                                                    return-object
                                                    @change="onChangedSick" />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                                <v-select
                                                    dense
                                                    v-model="conditions.vermin" 
                                                    label="害虫" 
                                                    outlined 
                                                    hide-details
                                                    :items="vermins" 
                                                    item-text="name"
                                                    clearable
                                                    return-object
                                                    @change="onChangedVermin" />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-simple-table v-if="!$vuetify.breakpoint.xs" fixed-header dense :height="600">
                                <thead>
                                    <tr>
                                        <th class="text-end">No.</th>
                                        <th class="text-start ma-3" style="width:100%">農薬名</th>
                                        <th class="text-center">回数/制限</th>
                                        <th class="text-center">使用時期</th>
                                        <th class="text-start">その他</th>
                                        <!-- <th class="text-center">希釈倍率</th>
                                        <th class="text-center">系統</th>
                                        <th class="text-center">分類</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="chemical in agrichemicals">
                                        <template v-if="selectedAgrichemicals.findIndex((v)=>v.agrichemicalNo == chemical.body.agrichemicalNo) < 0">
                                            <tr :key="chemical.body.agrichemicalNo" :style="agrichemicalListRowStyle(chemical)" @click="onClickAgrichemical(chemical)">
                                                <td class="text-end">{{chemical.body.agrichemicalNo}}</td>
                                                <td class="text-start">{{chemical.body.name}}</td>
                                                <td class="text-center subtitle-1">{{agrichemicalUsedNum(chemical)}}</td>
                                                <td class="text-center">
                                                    {{agrichemicalUseTime(chemical)}}
                                                </td>
                                                <td class="text-start caption">
                                                    希釈倍率:{{agrichemicalDilution(chemical)}}<br/>
                                                    系統:{{chemical.body.strain}}<br/>
                                                    分類:{{chemical.body.classificationCode}}
                                                </td>
                                                <!-- <td class="text-center">
                                                    {{agrichemicalDilution(chemical)}}
                                                </td>
                                                <td class="text-center">{{chemical.body.strain}}</td>
                                                <td class="text-center">{{chemical.body.classificationCode}}</td> -->
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </v-simple-table>
                            <v-simple-table v-else fixed-header dense :height="400">
                                <template v-for="chemical in agrichemicals">
                                    <template v-if="selectedAgrichemicals.findIndex((v)=>v.agrichemicalNo == chemical.body.agrichemicalNo) < 0">
                                        <tr :key="chemical.body.agrichemicalNo">
                                            <td>
                                                <v-card class="ma-1" :style="agrichemicalListRowStyle(chemical)" @click="onClickAgrichemical(chemical)">
                                                    <table style="width:100%">
                                                        <tr>
                                                            <td style="width:40px; text-align:center">{{chemical.body.agrichemicalNo}}</td>
                                                            <td >
                                                                {{chemical.body.name}}<br/>
                                                                <v-divider />
                                                                <span style="font-size:xx-small">
                                                                    使用時期:{{agrichemicalUseTime(chemical)}}<br/>
                                                                    希釈倍率:{{agrichemicalDilution(chemical)}}<br/>
                                                                    系統:{{chemical.body.strain}} / 分類:{{chemical.body.classificationCode}}
                                                                </span>
                                                            </td>
                                                            <td style="width:40px; text-align:center">
                                                                {{agrichemicalUsedNum(chemical)}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-card>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <span v-if="!$vuetify.breakpoint.xs">({{targetAgrichemicalBase.body.source}}より)</span>
                        <span v-else style="font-size:xx-small">({{targetAgrichemicalBase.body.source}}より)</span>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }
    Date.prototype.diffMonth = function (d) {
        return (this.getFullYear() * 12 + this.getMonth()) - (d.getFullYear() * 12 + d.getMonth())
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton,
        },
        props: {
            /** 対象の場所 */
            targetPlace: null,
            /** 既に選択されている全農薬(ここに格納されている薬品は一覧に表示しない) */
            //     {
            //         /** 対象農薬 */
            //         target: 0,
            //         /** 農薬No. */
            //         agrichemicalNo: 0,
            //         /** 希釈倍率 */
            //         dilution: 100,
            //         /** 散布量 */
            //         prevatication: 50,
            //         /** 回数(起点日から何回目の使用になるか) */
            //         count: 0
            //     }
            selectedAgrichemicals: [],
            /** 作業日(使用回数の算出の為) */
            workDate: "",
            /** 農薬管理の日付範囲 */
            managementDateRange: null
        },
        data: function () {
            return {
                isView: false,
                conditions: {
                    name: "",
                    sick: null,
                    vermin: null
                },
                /** 病気セレクターの選択項目を格納する配列 */
                sicks: [],
                /** 害虫セレクターの選択項目を格納する配列 */
                vermins: [],
                /** 農薬一覧表示用の配列 */
                agrichemicals: []
            }
        },
        computed: {
            targetAgrichemicalBase: function () {
                return this.$store.getters["managementItems/agrichemicals"].find((v)=>v.body.target == this.targetPlace.body.managementAgrichemical.target)
            }
        },
        watch: {
            conditions: {
                handler: function (value, old) {
                    this.refreshAgrichemicalList()
                },
                deep: true
            }
        },
        created: function () {
            this.sicks = []
            const sicks = this.$store.getters["managementItems/sicks"]
            for (var key in sicks.list) {
                this.sicks.push(sicks.list[key])
            }

            this.vermins = []
            const vermins = this.$store.getters["managementItems/vermins"]
            for (var key in vermins.list) {
                this.vermins.push(vermins.list[key])
            }

            if (this.targetPlace.agrichemicalsHistory == null) {
                this.targetPlace.agrichemicalsHistory = {
                    version: "1.0.0",
                    placeID: this.targetPlace.body.placeID,
                    target: this.targetPlace.body.managementAgrichemical.target,
                    agrichemicals: {}
                }
            }
        },
        methods: {
            /**
             * 病気選択時
             * 害虫の選択をクリアする。
             */
            onChangedSick: function () {
                if (this.conditions.sick != null) {
                    this.conditions.vermin = null
                }
            },
            /**
             * 害虫選択時
             * 病気の選択をクリアする。
             */
            onChangedVermin: function () {
                if (this.conditions.vermin != null) {
                    this.conditions.sick = null
                }
            },
            /**
             * 農薬選択時
             */
            onClickAgrichemical: function (agrichemical) {
                this.$emit("onSelectedAgrichemical", agrichemical)
                this.isView = false
            },
            /**
             * 農薬リストの各行の表示スタイル
             */
            agrichemicalListRowStyle: function (chemical) {
                const style = {
                    backgroundColor: "rgba(255,255,255,1)",
                    color: "rgba(0,0,0,1)"
                }
                // 背景色
                if (chemical.isConditionTarget) {
                } else {
                    style.backgroundColor = "rgba(238,238,238,1)"
                }
                // 文字色
                const usedNum = chemical.usedNum
                if (chemical.body.useLimitNum == 0 || usedNum < chemical.body.useLimitNum) {
                } else if (usedNum >= chemical.body.useLimitNum) {
                    style.color = "rgba(255,0,0,1)"
                }
                // console.log(useNum, chemical.useLimitNum, style)
                return style
            },
            /**
             * 農薬一覧の表示を更新
             */
            refreshAgrichemicalList: function () {
                // console.log("refreshAgrichemicalList")
                const self = this

                // システムに登録されている農薬が条件に一致するかをチェックし、結果をセットする。
                for (var i=0; i<this.agrichemicals.length; i++) {
                    const chemical = this.agrichemicals[i]

                    if (this.conditions.sick != null) {
                        // 病気が選択されている時
                        chemical.isConditionTarget = chemical.body.sicks.find((v)=>v == this.conditions.sick.sickNo) != null ? true : false
                    } else if (this.conditions.vermin != null) {
                        // 害虫が選択されている時
                        chemical.isConditionTarget = chemical.body.vermins.find((v)=>v == this.conditions.vermin.verminNo) != null ? true : false
                    } else {
                        chemical.isConditionTarget = true
                    }
                    // 病気、害虫の条件に該当すれば、名前の条件をチェック
                    if (chemical.isConditionTarget && this.conditions.name != null && this.conditions.name != "") {
                        if (chemical.body.name.indexOf(this.conditions.name) < 0) {
                            chemical.isConditionTarget = false
                        }
                    }
                }

                console.log("refresh", this.agrichemicals)
                
                this.agrichemicals.sort(function(x, y){
                    if (x.isConditionTarget && !y.isConditionTarget) {
                        return -1
                    }
                    if (!x.isConditionTarget && y.isConditionTarget) {
                        return 1
                    }
                    if (x.body.agrichemicalNo < y.body.agrichemicalNo) {
                        return -1
                    }
                    if (x.body.agrichemicalNo > y.body.agrichemicalNo) {
                        return 1
                    }
                    if (x.body.agrichemicalNo == y.body.agrichemicalNo) {
                        return 0
                    }
                })

                // console.log(this.agrichemicals)
            },
            /**
             * 指定された農薬の一覧に表示する回数を返す
             */
            agrichemicalUsedNum: function (agrichemical) {
                
                const useLimitNum = agrichemical.body.useLimitNum == 0 ? "" : " / " + agrichemical.body.useLimitNum
                const usedNum = agrichemical.usedNum
                return usedNum + useLimitNum
            },
            /**
             * 指定された農薬の一覧に表示する使用時期を返す
             */
            agrichemicalUseTime: function (agrichemical) {
                if (agrichemical.body.useTime.type != null) {
                    switch (agrichemical.body.useTime.type) {
                        case 1:
                            if (agrichemical.body.useTime.value == "1") {
                                return "収穫前日まで"
                            }
                            if (agrichemical.body.useTime.value == "0") {
                                return "収穫当日まで"
                            }
                            return "収穫" + agrichemical.body.useTime.value + "日前まで"
                        case 99:
                            return agrichemical.body.useTime.value
                    }
                }
            },
            /**
             * 指定された農薬の一覧に表示する希釈倍率を返す
             */
            agrichemicalDilution: function (agrichemical) {
                if (agrichemical.body.dilution.min != null && agrichemical.body.dilution.max != null) {
                    return agrichemical.body.dilution.min + "～" + agrichemical.body.dilution.max
                } else if (agrichemical.body.dilution.min != null) {
                    return agrichemical.body.dilution.min
                } else if (agrichemical.body.dilution.max != null) {
                    return agrichemical.body.dilution.max
                }
            },
            /**
             * このダイアログを表示
             */
            show: function () {

                this.agrichemicals = []

                for (var key in this.targetAgrichemicalBase.items) {

                    const chemical = this.targetAgrichemicalBase.items[key]

                    this.agrichemicals.push(
                        {
                            body: chemical,
                            isConditionTarget: true,
                            usedNum: this.getAgrichemicalUsedNumOf(chemical)
                        }
                    )
                }

                this.refreshAgrichemicalList()

                this.isView = true
            },
            /**
             * 指定された農薬の作業日の年度の使用回数を返す
             */
            getAgrichemicalUsedNumOf: function (agrichemical) {

                const self = this
                const chemicalHistory = this.targetPlace.agrichemicalsHistory.agrichemicals[agrichemical.agrichemicalNo]

                // console.log("getAgrichemicalUsedNumOf", agrichemical.agrichemicalNo, chemicalHistory, this.targetPlace)

                if (chemicalHistory == null) {
                    return 0
                }
                
                const histories = chemicalHistory.histories.filter(function (v) {return v.date >= self.managementDateRange.startDate && v.date <= self.workDate})

                return histories.length

                // // 回数を管理する日付の範囲を算出
                // var workDate = new Date(this.workDate)
                // var startDate = new Date(workDate.getFullYear(), this.targetPlace.body.managementAgrichemical.startDate.month - 1, this.targetPlace.body.managementAgrichemical.startDate.day)
                // if (workDate < startDate) {
                //     startDate = new Date(workDate.getFullYear() - 1, this.targetPlace.body.managementAgrichemical.startDate.month - 1, this.targetPlace.body.managementAgrichemical.startDate.day)
                // }
                // var endDate = (new Date(startDate.getFullYear()+1, startDate.getMonth(), startDate.getDate())).addDay(-1)

                // const startDateText = startDate.toFormatString("yyyy-MM-dd")
                // const endDateText = endDate.toFormatString("yyyy-MM-dd")

                // // 履歴から算出した日付の範囲内の件数を取得して返す
                // const chemicalHistory = this.targetPlace.agrichemicalsHistory.agrichemicals[agrichemical.agrichemicalNo]
                // const usedNum = chemicalHistory != null ? chemicalHistory.histories.filter(function (v) {return v.date >= startDateText && v.date <= endDateText}).length : 0

                // return usedNum
            },
        }
    }
</script>
